export const locationMetaData = async (url, location, userId, axiosInstance) => {
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    const { data } = await axiosInstance.put(`${baseUrl}/chat-bot/${userId}/meta-data`, {
        "chat_session_origin_url": url,
        "chat_session_customer_location": location
    });
    return data;
}